import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Target, BarChart3, MonitorPlay } from 'lucide-react';
export function DifferentiationSlide() {
  return <div className="h-full flex flex-col" data-id="element-144">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 h-full items-center" data-id="element-145">
        {/* Left: Points */}
        <div className="space-y-6" data-id="element-146">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} className="flex gap-4" data-id="element-147">
            <div className="mt-1 p-2 rounded-lg bg-purple-50 text-purple-600 h-fit" data-id="element-148">
              <ShieldCheck className="w-6 h-6" data-id="element-149" />
            </div>
            <div data-id="element-150">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-151">
                Deep Vertical Expertise & Master Agreements
              </h3>
              <p className="text-gray-500" data-id="element-152">
                Navigating regulated environments where generalist AI fails.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.15
        }} className="flex gap-4" data-id="element-153">
            <div className="mt-1 p-2 rounded-lg bg-blue-50 text-blue-600 h-fit" data-id="element-154">
              <Target className="w-6 h-6" data-id="element-155" />
            </div>
            <div data-id="element-156">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-157">
                One-to-One
              </h3>
              <p className="text-gray-500" data-id="element-158">
                Precision delivery vs agencies' broad-stroke campaigns.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3
        }} className="flex gap-4" data-id="element-159">
            <div className="mt-1 p-2 rounded-lg bg-emerald-50 text-emerald-600 h-fit" data-id="element-160">
              <MonitorPlay className="w-6 h-6" data-id="element-161" />
            </div>
            <div data-id="element-162">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-163">
                Interactive Engagement Platform
              </h3>
              <p className="text-gray-500" data-id="element-164">
                Proprietary engagement layer driving measurable outcomes.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.45
        }} className="flex gap-4" data-id="element-165">
            <div className="mt-1 p-2 rounded-lg bg-green-50 text-green-600 h-fit" data-id="element-166">
              <BarChart3 className="w-6 h-6" data-id="element-167" />
            </div>
            <div data-id="element-168">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-169">
                Compounding Flywheel
              </h3>
              <p className="text-gray-500" data-id="element-170">
                Behavioral data refines the model weekly, increasing the gap.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Right: Graph Visualization */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4
      }} className="relative h-[420px] bg-gray-50 rounded-2xl border border-gray-200 p-8 pb-16 flex flex-col" data-id="element-171">
          <h4 className="text-sm font-medium text-gray-400 mb-4 uppercase tracking-wider" data-id="element-172">
            Expertise Spectrum
          </h4>

          <div className="flex-1 relative" data-id="element-173">
            {/* Grid Lines */}
            <div className="absolute inset-0 flex flex-col justify-between opacity-20" data-id="element-174">
              <div className="w-full h-px bg-gray-300" data-id="element-175" />
              <div className="w-full h-px bg-gray-300" data-id="element-176" />
              <div className="w-full h-px bg-gray-300" data-id="element-177" />
              <div className="w-full h-px bg-gray-300" data-id="element-178" />
              <div className="w-full h-px bg-gray-300" data-id="element-179" />
            </div>

            {/* Vertical grid lines at label positions */}
            <div className="absolute inset-0 flex justify-between opacity-10" data-id="element-180">
              <div className="h-full w-px bg-gray-400" data-id="element-181" />
              <div className="h-full w-px bg-gray-400" data-id="element-182" />
              <div className="h-full w-px bg-gray-400" data-id="element-183" />
              <div className="h-full w-px bg-gray-400" data-id="element-184" />
              <div className="h-full w-px bg-gray-400" data-id="element-185" />
            </div>

            <svg className="absolute inset-0 w-full h-full" viewBox="0 0 500 280" preserveAspectRatio="none" data-id="element-186">
              {/* Red area fill under agency curve */}
              <motion.path d="M0 40 C 80 35, 150 50, 250 140 S 400 250, 500 265 L 500 280 L 0 280 Z" fill="url(#redFill)" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 1,
              delay: 0.8
            }} data-id="element-187" />
              {/* Purple area fill under Snakker curve */}
              <motion.path d="M0 260 C 100 255, 180 240, 250 140 S 380 30, 500 20 L 500 280 L 0 280 Z" fill="url(#purpleFill)" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 1,
              delay: 1.2
            }} data-id="element-188" />

              {/* Red Curve (Creative Agency) — starts high left, drops to low right */}
              <motion.path d="M0 40 C 80 35, 150 50, 250 140 S 400 250, 500 265" fill="none" stroke="#EF4444" strokeWidth="3.5" strokeLinecap="round" initial={{
              pathLength: 0
            }} animate={{
              pathLength: 1
            }} transition={{
              duration: 1.5,
              ease: 'easeInOut'
            }} data-id="element-189" />

              {/* Purple Curve (Snakker) — starts low left, rises to high right */}
              <motion.path d="M0 260 C 100 255, 180 240, 250 140 S 380 30, 500 20" fill="none" stroke="#7C3AED" strokeWidth="4" strokeLinecap="round" initial={{
              pathLength: 0
            }} animate={{
              pathLength: 1
            }} transition={{
              duration: 1.5,
              ease: 'easeInOut',
              delay: 0.3
            }} data-id="element-190" />
              {/* Purple glow */}
              <motion.path d="M0 260 C 100 255, 180 240, 250 140 S 380 30, 500 20" fill="none" stroke="#7C3AED" strokeWidth="14" strokeOpacity="0.08" strokeLinecap="round" initial={{
              pathLength: 0
            }} animate={{
              pathLength: 1
            }} transition={{
              duration: 1.5,
              ease: 'easeInOut',
              delay: 0.3
            }} data-id="element-191" />

              {/* Crossover dot */}
              <motion.circle cx="250" cy="140" r="5" fill="white" stroke="#7C3AED" strokeWidth="2" initial={{
              scale: 0,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              delay: 1.5
            }} data-id="element-192" />

              <defs data-id="element-193">
                <linearGradient id="redFill" x1="0" y1="0" x2="0" y2="1" data-id="element-194">
                  <stop offset="0%" stopColor="#EF4444" stopOpacity="0.08" data-id="element-195" />
                  <stop offset="100%" stopColor="#EF4444" stopOpacity="0.02" data-id="element-196" />
                </linearGradient>
                <linearGradient id="purpleFill" x1="0" y1="0" x2="0" y2="1" data-id="element-197">
                  <stop offset="0%" stopColor="#7C3AED" stopOpacity="0.12" data-id="element-198" />
                  <stop offset="100%" stopColor="#7C3AED" stopOpacity="0.02" data-id="element-199" />
                </linearGradient>
              </defs>
            </svg>

            {/* Curve Labels */}
            <motion.div initial={{
            opacity: 0,
            y: -5
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 1.2
          }} className="absolute top-2 left-[5%] flex items-center gap-1.5" data-id="element-200">
              <div className="w-5 h-0.5 bg-red-400 rounded" data-id="element-201" />
              <span className="text-red-500 text-xs font-semibold bg-white/80 px-1.5 py-0.5 rounded" data-id="element-202">
                Agency expertise
              </span>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: -5
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 1.4
          }} className="absolute top-2 right-[5%] flex items-center gap-1.5" data-id="element-203">
              <div className="w-5 h-0.5 bg-purple-600 rounded" data-id="element-204" />
              <span className="text-purple-600 text-xs font-semibold bg-white/80 px-1.5 py-0.5 rounded" data-id="element-205">
                Snakker expertise
              </span>
            </motion.div>
          </div>

          {/* X-Axis Labels */}
          <div className="flex justify-between items-end mt-3 text-xs text-gray-500 relative" data-id="element-206">
            <div className="text-left" data-id="element-207">
              <div className="font-bold text-gray-700 text-sm" data-id="element-208">One-to-many</div>
            </div>
            <div className="text-right" data-id="element-209">
              <div className="font-bold text-purple-600 text-sm" data-id="element-210">
                One-to-one
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}